var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.fontSize, _vm.textAlign]},[_c('i',{staticClass:"tidal-icon",class:[_vm.iconclass, _vm.iconStroke],style:(_vm.iconFill),domProps:{"innerHTML":_vm._s(_vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }